export default __webpack_public_path__ + "static/media/32580_copy-removebg 1.62913b83.svg";